import { FeatureList } from 'core/constants/common';
import Feature from './feature';

export default class ReportBuilder extends Feature {
  constructor(disabledFeatures: string[]) {
    super(FeatureList.reportBuilder, disabledFeatures);
  }

  isAccessible(): boolean {
    return super.isRouteAccessible();
  }
}
